import axios from "axios";
import JwtService from "@/core/services/jwt.service";

const ApiService = {
    
    init() {
        axios.defaults.headers['Accept-Language'] = 'en-EN';
        axios.defaults.baseURL = process.env.VUE_APP_URL_BACKEND;
        
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },

    setHeader() {
        
        axios.defaults.headers.common[ "Authorization" ] = `Bearer ${JwtService.getToken()}`;
    },
  
    notHeader() {
        delete axios.defaults.headers.common['Authorization'];
    },

    query(resource, params) {
        return axios.get(resource, params).catch(error => {
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    get(resource, slug = "") {
        return axios.get(`${resource}/${slug}`);
    },

    post(resource, data) {
        return axios.post(`${resource}`, data);
    },

    update(resource, slug, data) {
        return axios.put(`${resource}/${slug}`, data);
    },

    put(resource, data) {
        return axios.put(`${resource}`, data);
    },

    delete(resource) {
        return axios.delete(resource);
    }
};

export default ApiService;